(function ($) {

    $(document).ready(function () {

        var stickyCta = $('.JS--sticky-cta');
        if(stickyCta.length !== 0){
            var stickyCtaTop = stickyCta.offset().top;

            var endSticky = $('.s-sustainability-elements').offset().top + $('.s-sustainability-elements').outerHeight() - 40;

            $(window).scroll(function() {

                var stickyMenuHeight = $('.JS-s-anchors-menu').outerHeight();
                var containerLeftOffset = $('.s-sustainability-intro .container').offset().left + 15;
                var windowTop = $(window).scrollTop();
                var dynamicCtaBottom = stickyCta.offset().top + stickyCta.outerHeight();


                if (stickyCtaTop < windowTop + stickyMenuHeight) {
                    stickyCta.addClass('c-cta-sticky--fixed');
                     stickyCta.css('right',containerLeftOffset);

                    if(endSticky < dynamicCtaBottom ){
                        console.log('time unpin');
                    }


                } else {
                    stickyCta.removeClass('c-cta-sticky--fixed');
                    stickyCta.css('right',0);
                }
            });

        };


        var postCTA = $('.c-single-post-header__content');
        if(postCTA.length !== 0){
            var postCTATop = postCTA.offset().top;
            $(window).scroll(function() {
                var windowTop = $(window).scrollTop();
                if (postCTATop < windowTop) {
                    $('.c-social-share__upright').addClass('JS--started')
                }
                else{
                    $('.c-social-share__upright').removeClass('JS--started')
                }
            });
        };

    });


})(jQuery);







